import React, { ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import HeaderComp from '../Respond/HeaderComp';
import SideMenu from '../Respond/Sidemenu';
import VideoPlayer from 'src/components/VideoPlayer';
import { IoPlaySkipBackSharp, IoPlaySkipForward } from 'react-icons/io5';
import { FiArrowLeft, FiArrowRight, FiCrop, FiFileText, FiMusic } from 'react-icons/fi';
import VideoTimelineEditor from 'src/pages/Edit/VideoTimelineEditor';
import ReactPlayer from 'react-player';
import { QcastSidebar } from './QcastSidebar';
import { useNavigate } from 'react-router-dom';
import { trimTime } from 'src/shared/utils/record-functions';
import { useBoundStore } from 'src/store';
import { generateVideoThumbnail, getVideoBlobDuration, MAX_SAMPLES, WHISPER_SAMPLING_RATE } from 'src/shared/utils/helper';
// import useASRWorker from "src/hooks/useASRWorker";

import Loader from "src/assets/icons/loader.svg"
import { ProgressProvider } from 'src/ProgressContext';
import eventEmitter from 'src/shared/utils/eventEmitter';

import { useASR } from "src/context/ASRContext";
import useRecorder from 'src/hooks/useRecorder';
import MultipleVideoPlayer from 'src/components/MultipleVideoPlayer';
import Modal from 'src/components/Modal';
import Process from './Process';
import useVideoTrim from 'src/hooks/useVideoTrim';
import { theme } from 'src/styles/theme';

// Define the props interface for our component
interface IndexedVideo {
    index: number;
    video: any;
    editedBlob?: any;
    duration?: number;
    positions?:{start:number,end:number}
}
interface EditQcastStudioProps {
  videos: IndexedVideo[];
  ffmpeg: any;
}

// Styled Components
const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0px;
    color: #000;
    height:100%;
    // padding: 40px 40px 0px 40px;
`;

const ContentArea = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 0px;
`;

const Content = styled.div`
  width: 380px;
  // height: 534px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  @media (max-width: ${theme.breakpoints.mobile}px) {
    width: 300px;
  } 
`;

const VideoArea = styled.div`
  width: 100%;
  height: auto;
  justify-content: space-between;

  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: space-between;
  padding: 32px 32px;

  z-index: 999999999;
  padding-top: 0px;
  @media (max-width: ${theme.breakpoints.tablet}px) {
    padding: 32px 20px ;
    gap: 15px;
  }
  @media (max-width: ${theme.breakpoints.mobile}px) {
    padding: 32px 10px ;
    gap: 15px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

const EditArea = styled.div`
    width: 100%;
    height: auto;
    border-top-width: 1px;
    margin-top:auto;
    background: #F2F2F4;

    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    // padding-bottom: 48px;
    padding-top: 0px;
    gap: 30px;

    z-index: 999999999;
     @media (max-width: ${theme.breakpoints.maxTablet}px) {
              height:100svh;
            }
`;


const RespondentContainer = styled.div<{size?: number}>`
  width: 100%;
  //height: ${props=>props.size || 480}px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 999999999999;
  aspect-ratio:1 / 1;
  
`;


const Controls = styled.div`
    height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  z-index: 999999999999999;
  
`;

const ControlButton = styled.button<{ active?: boolean }>`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: #989392;
  color: #1a1a21;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    transform: scale(1.05);
  }
`;

const SideTools = styled.div`
    // width: 616px;
    height: 50vh;
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: center;
    gap: 16px;
    z-index: 999999999999999;

    @media (max-width: ${theme.breakpoints.mobile}px) {
      width: 100%;
      height: 100%;

      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    
`;

const ToolButton = styled.button<{ active?: boolean }>`
  width: 48px;
  height: 48px;
  border-radius: 8px;

  border-radius: 15px;
  border: none;
  background-color: #FFFFFF;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  

  ${props=>props.active && css`
    background: #00000014;
  `}
`;

const GroundToolButton = styled.div`
    width: 64px;
    // height: 176px;
    gap: 8px;
    border-radius: 15px;
    padding: 8px;

    background: #FFFFFFB2;
    box-shadow: 0px 6px 60px 0px #00000014;

    box-shadow: 0px 4px 64px 0px #FFFFFF1F inset;


    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;

    border-radius: 15px;

    @media (max-width: ${theme.breakpoints.mobile}px) {
      height: 64px;
      width: auto;
      flex-direction: row;
    }
`;


// Main component
const EditQcastStudio: React.FC<EditQcastStudioProps> = ({
  videos,
  ffmpeg,
}) => {

  const [startPos, setStartPos] = useState({a: 0});
  const [endPos, setEndPos] = useState({a: 0});
  const [startTime, setStartTime] = useState(startPos.a);
  const [endTime, setEndTime] = useState(endPos.a);

  const [tranStatus, settransStatus] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [playerIsReady, setPlayerIsReady] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [currentVideo, setCurrentVideo] = useState<any>(null);
  const [currentVideoTool, setCurrentVideoTool] = useState<string>("crop");
  const [progress, setProgress] = useState<number>(0);
  const [tempPlayers, setTempPlayers] = useState<ReactNode[]>([]);
  const [totalDuration, setTotalDuration] = useState<number>(0);
  const [progressLoader, setProgressLoader] = useState<number>(0);
  const [currentVideoUrl, setCurrentVideoUrl] = useState<string>("");

  
  const [isSocialModalOpen, setIsSocialModalOpen] = useState(false);


  const [multiVideo, setMultiVideo] = useState<any[]>([]);
  
  const { handleTrimVideo}=useVideoTrim()
 

  const progressRef = useRef(0);

  const vidRef = useRef(null);
  const audioContextRef = useRef<AudioContext | null>(null);

  // const { 
  //   isModelLoaded, 
  //   isTranscribing, 
  //   transcriptions,
  //   transcribeMultipleAudios 
  // } = useASRWorker();
    


  const navigate = useNavigate();

  const {updateRecordedVideo, videoTranscription, setThumbnail, setTranscriptionComplete} = useBoundStore();

 var progres=0

  const handleProgress = (prog: number) => {
   // setProgress(prog)
  }
  
  const validateProcess=(vid)=>{
    if(!vid.positions) return false;
    if(vid.positions.start==0 && vid.positions.end==vid.duration) return false;
    return true;


  }
  const handleControlBtnClick = (index: number)=>{

    if(index === -1 && currentIndex === 0) return;
    if(index === 1 && currentIndex === videos.length - 1) return;
    setCurrentIndex((prev)=>prev+index);
  }

  const handleCountChange = (count: number) => {
  };
  const handlePlay = useCallback((value: boolean) => {
    setPlaying(value);
  }, []);
  
  const handlePause = useCallback(() => {
  }, []);
  
  const handleVideoEnded = useCallback(() => {
    setPlaying(false);
  }, []);

  const handleAction = async() =>{

    setIsSocialModalOpen(true)
    let currentIndexs=0;
    const loaderCounter=100/videos.length
    
    for(const vid of videos){
      setProgressLoader(loaderCounter)
      
      const validator=validateProcess(vid);
      
      let resVid=vid.video;
      try {
        if(validator){
          const process=await handleTrimVideo(vid,vid.positions.start,vid.positions.end)
          if(process){
            resVid=process
          }
          
        }
        
      } catch (error) {
        console.error(error)
      }finally{
       console.log("resVid",resVid)
        await updateRecordedVideo(currentIndexs, { editedBlob: resVid });
      }
      
      
      currentIndexs++
    }
    setProgressLoader(0)
    setIsSocialModalOpen(false)
    navigate("/qcast/review")
  }

  const handleProcess=()=>{
    navigate("/qcast/review")

  }

  const onTrimmingChange = async(blob: Blob | null,positions?:{start:number,end:number}) => {
    await updateRecordedVideo(currentIndex, { editedBlob: blob,positions });
  }

  const onThumbNail = async(frame: any) => {
    await setThumbnail(frame );
  }

  const handlePlayerReadyStatus = useCallback((status: boolean)=>{
    setPlayerIsReady(status);
    if(status){
      handleTranscriptionStart();
    }
  }, [])

  const handleVideoTap = (index: number)=>{
    setCurrentIndex(index);
    setCurrentVideo(videos[index]);
  }
  

  const handleTranscriptionStart = async () => {
    settransStatus(true);
    setTranscriptionComplete(false);
    eventEmitter.emit('transcription-start');
    try {
      const audioItems = [];
      
      for (let i = 0; i < videos.length; i++) {
        const video: any = videos[i];
        if (!video) continue;
        
        try {
          const blob = video?.editedVideo || video?.video;
          const arrayBuffer = await blob.arrayBuffer();
          
         
          const audioContext = new AudioContext({ sampleRate: WHISPER_SAMPLING_RATE });
          const decoded = await audioContext.decodeAudioData(arrayBuffer);
          
          
          let audio = decoded.getChannelData(0);
          if (audio.length > MAX_SAMPLES) {
            audio = audio.slice(-MAX_SAMPLES);
          }
          
          
          await audioContext.close();
          
          
          audioItems.push({
            audio,
            language: "en",
            index: i
          });
        } catch (error) {
          console.error(`Error extracting audio from video ${i}:`, error);
        }finally{
          eventEmitter.emit('transcription-end', { success: true });
        }
      }
      
      // await transcribeMultipleAudios(audioItems);
      await setTranscriptionComplete(true);
      
    } catch (error) {
      console.error("Transcription process failed:", error);
    }finally{
      settransStatus(false);
    }
  };

  
  

  useEffect(()=>{
    if(videos.length > 0){
      setCurrentVideo(videos[currentIndex]);
    }
  }, [currentIndex]);


  // useEffect(()=>{
  //     const total = videos.reduce((sum, video) => sum + video?.duration, 0);
  //     setTotalDuration(total);
  // }, [videos]);


  
  const handleDuration = (duration: any, index: number) => {
    
    if ( isFinite(duration) && !isNaN(duration)){
      let totalDurationUpdate=totalDuration+duration
      setTotalDuration(totalDurationUpdate);
    }
    
  };
  
/*   useEffect(() => {
    if(videos.length > 0){
      setCurrentVideo(videos[0]);
      const preloadVideos = async () => {
        setTotalDuration(0)
        const players: any[] = videos.map((video, index) => (
          <ReactPlayer
            key={index}
            url={isBlob(video.editedBlob) && isValidBlob(video.editedBlob) ? URL.createObjectURL(video.editedBlob) : URL.createObjectURL(video.video)}
            //onDuration={(duration) => handleDuration(duration, index)}
            onReady={(e)=>handleDuration(e.getDuration(), index)}
            style={{ display: 'none' }}
            preload="metadata"
          />
        ));
        setTempPlayers(players);
      };

      preloadVideos();
    }
    
  }, [videos]); */
  

  // useEffect(()=>{
  // }, [currentVideo]);

  // useEffect(()=>{
  // }, [videos]);

  useEffect(() => {
    if (!currentVideo) {
      setCurrentVideoUrl("");
      return;
    }
    
    let url = "";
    if (currentVideo?.editedBlob instanceof Blob) {
      url = URL.createObjectURL(currentVideo.editedBlob);
    } else if (currentVideo?.video instanceof Blob) {
      url = URL.createObjectURL(currentVideo.video);
    }
    
    setCurrentVideoUrl(url);
    
    
    return () => {
      if (url && url.startsWith("blob:")) {
        URL.revokeObjectURL(url);
      }
    };
  }, [currentVideo]);


const handleNextVideo=(idx)=>{
  setCurrentIndex(idx)
  setPlaying(true)
}



useEffect(()=>{
  console.log("videos2",videos)
  setMultiVideo(videos.map(video=>({
    title:"", 
    duration:video.duration, 
    url:video && video.video ? URL.createObjectURL(video.video) : null
  })));
}, [videos.length]);


  return (
    <Container>
        <HeaderComp onCancel={()=>{}} onAction={handleAction} type="edit" color={"#000000"} />
        <ProgressProvider>
          <VideoArea >
            <SideMenu activeMenuItem="Edit"  color={"#000000"} disabledMenu={["Review"]} />
            <Content>
              <RespondentContainer size={380}>
                <div style={{zIndex: 999999999999999,width:"100%",height:"100%"}}>
                <MultipleVideoPlayer 
                        videos={multiVideo} 
                        currentIndex={currentIndex}
                        size={"320px"}
                        repeatVideoPlayback={false}
                        playing={playing}
                        muteVideo={false}
                        onVideoEnded={handleVideoEnded}
                        onProgress={handleProgress}
                        onDuration={()=>{}}
                        onPause={handlePlay}
                        onSeek={()=>{}}
                        onNextVideo={handleNextVideo}
                        
                    />
                  {/*      <VideoPlayer
                  vidSrc={currentVideoUrl}
                  ref={vidRef}
                  size={380}
                  showProgress={false}
                  showTimer={true}
                  hideSeek={true} 
                  hidePlayVideoIcon={true}
                  autoPlay={false}
                  play={playing}
                  onProgress={handleProgress} 
                  onDuration={()=>{}} 
                  onPause={()=>{}} 
                  onPlay={()=>{}} 
                  onReady={handlePlayerReadyStatus}
                  onVideoEnded={handleVideoEnded} 
                />  */} 
                </div>
                      
              </RespondentContainer>
              
              <Controls>
                <ControlButton onClick={()=>{handleControlBtnClick(-1)}}>
                    <FiArrowLeft color={"#C7C2C0"} size={20} />
                </ControlButton>
                
                <ControlButton onClick={()=>{handleControlBtnClick(1)}} >
                    <FiArrowRight color={"#C7C2C0"} size={20} />
                </ControlButton>
              </Controls>
                
            </Content>
            
            <SideTools>
            
             {/*    <GroundToolButton>
                    <ToolButton active={currentVideoTool === "crop"} onClick={()=>{setCurrentVideoTool("crop")}}>
                        <FiCrop color={"#000000"} size={24} />
                    </ToolButton>

                    <ToolButton active={currentVideoTool === "transcript"} onClick={()=>{handleTranscriptionStart()}}>
                        {tranStatus ? <img src={Loader} title="Transcribing video" /> : <FiFileText color={"#000000"} size={24} title="Transcribing video" />}
                    </ToolButton>
                     <ToolButton active={currentVideoTool === "sound"} onClick={()=>{setCurrentVideoTool("sound")}}>
                        <FiMusic color={"#000000"} size={24} />
                    </ToolButton> 
                </GroundToolButton> */}
            </SideTools>
          </VideoArea>
          <EditArea>
              <VideoTimelineEditor 
                index={currentIndex} 
                videos={videos} 
                ffmpeg={ffmpeg} 
                isPlayerReady={playerIsReady}
                progress={progress}
                onVideoTap={handleVideoTap}
                allVideoDuration={totalDuration}
                onTrimmingChange={onTrimmingChange}
                onThumbNail={onThumbNail}
                onPlay={handlePlay} />
                
          </EditArea>
        </ProgressProvider>
        {isSocialModalOpen && (
          <Modal
            isOpen={isSocialModalOpen}
            onClose={() => setIsSocialModalOpen(false)}
          >
            <Process   progress={progressLoader} />
          </Modal>
        )}
        {tempPlayers}
    </Container>
  );
};

export default EditQcastStudio;


